import { Section } from 'components/shared/Section';
import Loader from 'components/shared/spinner';
import { GET_ARTICLES } from 'lib/queries';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import sanityGraphQLClient from 'utils/sanityGraphQLClient';

import { ArticleCard } from './ArticleCard';

const StyledArticles = styled.div`
  .content-container {
    padding: 2em 0em 4em;

    .infinite-scroll {
      display: block;
      width: 100%;
    }

    .article-list {
      display: grid;
      gap: 2em;
      width: 100%;
      padding: 1em;

      .article {
        width: 100%;
        flex-grow: 1;
      }
    }

    @media screen and (min-width: 576px) {
      padding: 2em 0em 6em;

      .article-list {
        grid-template-columns: repeat(auto-fit, minmax(auto, 270px));
      }
    }
  }

  .pagination-container {
    padding: 0em 0 6em;
  }
`;

export const Articles = () => {
  const [isFetchingArticles, setIsFetchingArticles] = useState(false);
  const [articles, setArticles] = useState([]);
  const [offset, setOffset] = useState(0);
  const [shouldStopFetchingArticles, setShouldStopFetchingArticles] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 12;

  const handlePageChange = (page) => {
    let updatedOffset = page * pageSize - pageSize;
    setCurrentPage(page);
    setOffset(updatedOffset);
  };

  const updateArticleList = (newArticles) => {
    setArticles((prevState) => {
      return [...prevState, ...newArticles];
    });
  };

  const fetchArticles = async () => {
    if (isFetchingArticles || shouldStopFetchingArticles) return;
    setIsFetchingArticles(true);

    try {
      const response = await sanityGraphQLClient(GET_ARTICLES, {
        where: {},
        sort: [{ publishedAt: 'DESC' }],
        limit: pageSize,
        offset: offset
      });

      if (response?.allPost) {
        if (response?.allPost.length < pageSize) {
          setShouldStopFetchingArticles(true);
        }

        updateArticleList(response.allPost);
      }
    } catch (error) {
      console.log(error);
    }

    setIsFetchingArticles(false);
  };

  useEffect(() => {
    fetchArticles();
  }, [offset]);

  return (
    <StyledArticles>
      <Section className="content-container">
        <InfiniteScroll
          dataLength={articles.length}
          next={() => handlePageChange(currentPage + 1)}
          hasMore={!shouldStopFetchingArticles}
          // loader={<h4>Loading...</h4>}
          className="infinite-scroll">
          <div className="article-list">
            {articles.map((article, i) => {
              return (
                <div className="article">
                  <ArticleCard key={`article-card-${i}`} article={article} />
                </div>
              );
            })}
          </div>
        </InfiniteScroll>

        {isFetchingArticles && <Loader />}
      </Section>

      {/* <div className='pagination-container'>
            <BrytaPagination
                pages={{ currentPage: currentPage || 1, itemCount: 10 }}
                onPageChange={handlePageChange}
          />
        </div> */}
    </StyledArticles>
  );
};
